import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BarComponent } from './bar.component';
import { ProgressDirective } from './progress.directive';
import { ProgressbarComponent } from './progressbar.component';
import { ProgressbarConfig } from './progressbar.config';
export var ProgressbarModule = (function () {
    function ProgressbarModule() {
    }
    ProgressbarModule.forRoot = function () {
        return { ngModule: ProgressbarModule, providers: [ProgressbarConfig] };
    };
    ProgressbarModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [ProgressDirective, BarComponent, ProgressbarComponent],
                    exports: [ProgressDirective, BarComponent, ProgressbarComponent]
                },] },
    ];
    /** @nocollapse */
    ProgressbarModule.ctorParameters = function () { return []; };
    return ProgressbarModule;
}());
//# sourceMappingURL=progressbar.module.js.map


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/ng2-bootstrap/progressbar/progressbar.module.js
// module id = ../../../../ng2-bootstrap/progressbar/progressbar.module.js
// module chunks = 4